import React, { FC } from "react";

import { KpkMedia } from "@keepeek/commons";
import { withSuspense } from "@keepeek/refront-components";
import { Box } from "@mui/material";
import clsx from "clsx";

export type MediaDetailHeaderActionsLayoutProps = {
  className: String;
  buttons: JSX.Element[];
  kpkMedia: KpkMedia;
  showAttachments: boolean;
  showAddToBasket: boolean;
  showUnitaryPublicShare: boolean;
};

const MediaDetailHeaderActionsLayout: FC<MediaDetailHeaderActionsLayoutProps> = function ({
  className,
  buttons,
}) {
  return (
    <Box
      className={clsx("MediaDetailHeaderActions", className)}
      sx={{
        display: "flex",
        padding: 1,
        height: "100%",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: 2,
      }}
    >
      {buttons}
    </Box>
  );
};
export default withSuspense(MediaDetailHeaderActionsLayout);
